@if (isLoadedFromPromo && loadSkeleton) {
    <cs-skeleton [enableNewSkeletonUI]="enableNewSkeletonUI" />
}

@if (isLobbyLoaded) {
    <cc-casino-page-container
        [lobbyType]="lobbyType"
        [categoryRoute]="categoryRoute"
        [gameContainer]="gameContainer"
        [seeAllProductLinkOverride]="seeAllProductLinkOverride">
    </cc-casino-page-container>
}

@if (isLobbyLoaded && isNewQuickInfoEnabled) {
    <cc-new-game-quick-info></cc-new-game-quick-info>
}
